export default "__VITE_ASSET__2a43cee0__"